import { render } from "./PersonalDataStep.vue?vue&type=template&id=593d3ef6"
import script from "./PersonalDataStep.vue?vue&type=script&lang=js"
export * from "./PersonalDataStep.vue?vue&type=script&lang=js"

import "./PersonalDataStep.vue?vue&type=style&index=0&id=593d3ef6&lang=css"

import exportComponent from "C:\\Users\\ser-mgk\\Documents\\Projekty\\CCS\\__DOPiK\\nowy-formularz-zgloszeniowy\\claim-form-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__